
import { Component, Vue } from 'vue-property-decorator';

import { Button } from 'ant-design-vue';
import { namespace } from 'vuex-class';

interface PageAccess {
  status: number;
  info: string;
}

const userModule = namespace('user');

@Component({
  components: {
    AButton: Button,
  },
})
export default class OverdueDialog extends Vue {
  // 用户信息
  @userModule.Getter('userInfo') userInfo: any;

  private visible: boolean = true;

  // 权限信息
  private get pageAccess(): PageAccess {
    const { pageAccess } = this.userInfo;
    return pageAccess;
  }

  private handleClose() {
    this.visible = false;
  }
}
